import tingle from 'tingle.js';
import form from '../form';
import share from './share';

let modal = null;

const getLinks = () => document.querySelectorAll('.js-modal');

const openModal = (data) => {
    // init new modal
    const opts = {
        stickyFooter: false,
        closeMethods: ['overlay', 'escape'],
        closeLabel: 'Close',
        onClose: () => {
            // stop Youtube videos playing
            const ytVideos = document.querySelectorAll('.js-yt-player');
            ytVideos.forEach((video) => {
                video.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
            });

            // stop inline videos playing
            const inlineVideos = document.querySelectorAll('.js-video-player');
            inlineVideos.forEach((video) => {
                video.pause();
            });

            // remove modals
            const modals = document.querySelectorAll('.tingle-modal');
            modals.forEach((el) => el.remove());
        },
    };

    if (data.class !== undefined) {
        opts.cssClass = [data.class];
    }

    // handle share links
    if (data.modal === 'share') {
        opts.onOpen = () => {
            share();
        };
    }

    // handle form
    if (data.class === 'form-modal'
        || data.class === 'download-modal') {
        opts.onOpen = () => {
            form();
        };
    }

    // build content
    let content;

    const closeBtnHTML = `
        <button class="group flex items-center justify-center absolute top-4 right-4 size-12 ml-auto border-2 border-lime bg-lime rounded-lg transition-colors hover:bg-green hover:border-green js-modal-close">
            <svg class="size-4"><use xlink:href="#icon-close" class="fill-green transition-colors group-hover:fill-white"></use></svg>
            <span class="sr-only">Close pop-up</span>
        </button>
    `;

    switch (data.modal) {
        case 'video':
            content = `
                <div class="relative h-0 max-w-full pb-9/16 overflow-hidden">
                    <video class="absolute top-0 left-0 w-full h-full js-video-player"
                        preload="metadata"
                        autoplay
                        loop
                        playsinline
                        controls
                        controlsList="nodownload">
                        <source src="${data.video}" type="video/mp4">
                    </video>
                </div>
                ${closeBtnHTML}
            `;
            break;
        case 'youtube':
            content = `
                <div class="relative h-0 max-w-full pb-9/16 overflow-hidden">
                    <iframe class="absolute top-0 left-0 w-full h-full js-yt-player"
                        width="640"
                        height="360"
                        src="https://www.youtube.com/embed/${data.video}?autoplay=1&enablejsapi=1"
                        frameborder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
                </div>
                ${closeBtnHTML}
            `;
            break;
        case 'eu-tyre-rating':
            content = document.querySelector(`.js-modal-${data.modal}`).innerHTML;
            content = content.replace('{{tyeprelid}}', data.tyeprelid);
            break;
        case 'form':
            content = document.querySelector(`.js-modal-${data.modal}`).innerHTML;
            content = content.replace(/{{modal}}/g, 'modal');
            content += closeBtnHTML;
            break;
        default:
            content = document.querySelector(`.js-modal-${data.modal}`).innerHTML;

            if (data.modal.includes('form')) {
                content = content.replace(/{{modal}}/g, 'modal');
                content += closeBtnHTML;
            }

            break;
    }

    // init
    modal = new tingle.modal(opts); // eslint-disable-line new-cap

    // set content
    modal.setContent(content);

    if (data.modal === 'eu-tyre-rating'
        && data.productInformationSheet !== undefined) {
        const image = modal.modal.querySelector('.js-modal-eu-tyre-rating-image');

        const a = document.createElement('a');
        a.href = data.productInformationSheet;
        a.target = '_blank';
        a.classList.add('flex', 'align-center', 'mt-6', 'font-semibold', 'underline');
        a.innerHTML = '<svg class="size-6 mr-3"><use xlink:href="#icon-research" class="fill-green"></use></svg>Information sheet';

        image.append(a);
    }

    // open modal
    modal.open();

    // close button
    const closeBtn = modal.modal.querySelector('.js-modal-close');
    if (closeBtn) {
        closeBtn.addEventListener('click', (event) => {
            event.preventDefault();
            modal.close();
        });
    }
};

const clickHandle = (event) => {
    event.preventDefault();
    const link = event.currentTarget;
    openModal(link.dataset);
};

const init = () => {
    const links = getLinks();
    if (links.length === 0) return;

    links.forEach((link) => {
        link.removeEventListener('click', clickHandle);
        link.addEventListener('click', clickHandle);
    });
};

export default init;
